import { FC, useCallback, useState } from "react";
import classes from './tutorLessons.module.scss'
import { OpenContainer } from "../../../../features/openContainer";
import { Content } from "../content/Content";

interface IProps {
    isOpen?: boolean;
    tutorId?: number;
}

export const TutorLessons: FC<IProps> = ({isOpen, tutorId}) => {

    const [trigger, setTrigger] = useState<number>(0)
    const onContentChange = useCallback(() => {
        setTrigger(prev => prev + 1)
    }, [])

    return (
        !isOpen 
            ?
        <section className={classes.container}>
            <section className={classes.title}>Занятия</section>
            <Content />
        </section>
            :
        <section className={`${classes.container} ${classes.isOpen}`}>
            <OpenContainer title="Занятия" trigger={trigger}>
                <section className={classes.content}>
                    <Content tutorId={tutorId} onContentChange={onContentChange} />
                </section>
            </OpenContainer>
        </section>
    )
}
